<template>
    <div
        :class="[
            { 'nav-pc': innerWidth > 425 },
            { 'nav-mobile': innerWidth <= 425 },
            'nav',
        ]">
        <CustomPcNav
            v-if="innerWidth > 425"
            :navList="navList"
            :activeNum.sync="activeNum" />
        <CustomMobileNav
            v-else
            :navList="navList"
            :activeNum.sync="activeNum" />
    </div>
</template>

<script>
import CustomMobileNav from "./CustomMobileNav/CustomMobileNav.vue";
import CustomPcNav from "./CustomPcNav/CustomPcNav.vue";
export default {
    name: "customNav",
    components: {
        CustomMobileNav,
        CustomPcNav,
    },
    props: {
        info: {
            type: Object,
            default: () => {},
        },
        activePage: {
            type: [String, Number],
            default: 0,
        },
    },
    data() {
        return {
            showMenu: false,
            activeNum: 0,
        };
    },
    computed: {
        // 获取当前路由列表
        navList() {
            const nav = this.$router.options.routes;
            return nav
                .map(item => {
                    if (item.meta.inNav)
                        return { title: item.meta.navName, name: item.name };
                })
                .filter(item => item !== undefined);
        },
    },
    watch: {
        // 监听导航缓存改变，传递给父级
        activeNum(n, o) {
            this.$emit("update:activePage", n);
        },
    },
    created() {
        this.activeNum = this.activePage;
    },
};
</script>

<style lang="scss" scoped>
.nav-pc {
    position: sticky;
    top: 0;
    z-index: 9999;
    background-color: #fff;
}
.nav-mobile {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
}
</style>
